import { FirestoreCreatorRepository } from '@infrastructure/firebase/firestore/FirestoreCreatorRepository';
import type { ICreatorsRepository } from '@domain/usecases/creators/CreatorsRepository';

export const makeCreatorRepository = (): ICreatorsRepository => {
	return new FirestoreCreatorRepository();
};
